( function ( $ ) {
    var $cart_form    = $( "form.cart" );
    var $variation_id = $cart_form.find( "input.variation_id[type='hidden'][name='variation_id']" );

    var $price_per_one          = $( "#price-per-one" );
    var $price_per_one_no_tax   = $price_per_one.find( ".price-no-tax-value bdi" );
    var $price_per_one_with_tax = $price_per_one.find( ".price-with-tax-value bdi" );

    var $price_for_all          = $( "#price-for-all" );
    var $price_for_all_no_tax   = $price_for_all.find( ".price-no-tax-value bdi" );
    var $price_for_all_with_tax = $price_for_all.find( ".price-with-tax-value bdi" );


    var on_variation_change = function () {
        var variation_id = parseInt( $variation_id.val().toString() );

        if (
            isNaN( variation_id )
            || typeof im_variations_prices !== "object"
            || typeof im_variations_prices[ variation_id ] !== "number"
        ) {
            return null;
        }

        var variation_price = im_variations_prices[ variation_id ];

        if ( ! variation_price ) {
            return;
        }

        im_product_price = variation_price;

        var event = new CustomEvent( "im_product_price_change", {
            bubbles: true
        } );

        document.dispatchEvent( event );
    };

    var refresh_prices = function () {
        var quantity = parseInt( im_quantity_input.val().toString() );

        if ( isNaN( quantity ) || quantity < 1 ) {
            quantity = null;
        }

        if (
            quantity === null
            || typeof im_product_price !== "number"
            || typeof im_product_tax_percent !== "number"
        ) {
            return;
        }

        var tax_coef = ( 1 + ( im_product_tax_percent / 100 ) );

        var price_per_one_no_tax   = im_calc_discount_price( im_product_price, quantity );
        var price_per_one_with_tax = ( price_per_one_no_tax * tax_coef );
        var price_for_all_no_tax   = ( price_per_one_no_tax * quantity );
        var price_for_all_with_tax = ( price_for_all_no_tax * tax_coef );

        $price_per_one_no_tax.text( im_format_price( price_per_one_no_tax ) );
        $price_per_one_with_tax.text( im_format_price( price_per_one_with_tax ) );
        $price_for_all_no_tax.text( im_format_price( price_for_all_no_tax ) );
        $price_for_all_with_tax.text( im_format_price( price_for_all_with_tax ) );

        if ( ( screen.width < 576 || quantity > 1 ) && $price_for_all.is( ":hidden" ) ) {
            // noinspection JSValidateTypes
            $price_for_all.fadeIn();
        }
    };

    var refresh_bulk_prices = function () {
        // Check required variables.
        if (
            typeof im_product_price !== "number"
            || typeof im_product_bulk_rules !== "object"
        ) {
            return;
        }

        // Clone bulk prices table.
        var $current_table = $( "#bulk-prices-table" );

        if ( $current_table.length === 0 ) {
            return;
        }

        var $new_table        = $current_table.clone();
        var $new_table_header = $new_table.find( "tr.table-bulk-prices-header" );
        var $new_table_values = $new_table.find( "tr.table-bulk-prices-values" );

        // Remove current values.
        $new_table_header.find( "th[data-quantity]" ).remove();
        $new_table_values.find( "td[data-quantity]" ).remove();

        // Fill table with new values.
        // Price for 1+ (if it isn't set as a rule).
        var $new_table_elements;

        if ( typeof im_product_bulk_rules["1"] !== "object" ) {
            $new_table_elements = build_bulk_table_elements( 1, im_product_price, 0 );
            $new_table_header.append( $new_table_elements.th );
            $new_table_values.append( $new_table_elements.td );
        }

        // Other prices.
        var quantities = Object.entries( im_product_bulk_rules );

        for ( var [quantity, sale] of quantities ) {
            quantity = ( typeof quantity === "string" ) ? parseInt( quantity ) : quantity;
            sale     = ( typeof sale === "string" ) ? parseFloat( sale ) : sale;

            if ( typeof quantity !== "number" || typeof sale !== "number" ) {
                continue;
            }

            var price           = ( im_product_price * ( ( 100 - sale ) / 100 ) );
            $new_table_elements = build_bulk_table_elements( quantity, price, sale );
            $new_table_header.append( $new_table_elements.th );
            $new_table_values.append( $new_table_elements.td );
        }

        // Replace bulk prices table.
        $current_table.replaceWith( $new_table );
    };

    /**
     * Builds <th> and <td> elements for bulk table.
     * @param {number} quantity
     * @param {number} price
     * @param {number} sale
     */
    var build_bulk_table_elements = function ( quantity, price, sale ) {
        // Heading.
        var $new_th = $( "<th></th>" )
            .attr( "data-quantity", quantity.toString() )
            .text( quantity + "+" );

        // Value.
        var $new_td = $( "<td></td>" )
            .attr( "data-quantity", quantity.toString() );

        // Price.
        var $new_td_price = $( "<span></span>" )
            .addClass( "text-nowrap" )
            .text( im_format_price( price ) );

        $new_td.append( $new_td_price );

        // Sale.
        if ( sale ) {
            var $new_td_sale = $( "<span></span>" )
                .addClass( "text-primary" )
                .addClass( "text-nowrap" )
                .text( "(-" + sale + " %)" );

            $new_td.append( $( "<br>" ) );
            $new_td.append( $new_td_sale );
        }

        // Return.
        return {
            th: $new_th,
            td: $new_td
        };
    };

    $variation_id.on( "change", on_variation_change );
    $( document ).ready( on_variation_change );

    im_quantity_input.on( "input", refresh_prices );
    $( document ).ready( refresh_prices );
    $( document ).on( "im_product_price_change", refresh_prices );

    $( document ).ready( refresh_bulk_prices );
    $( document ).on( "im_product_price_change", refresh_bulk_prices );
} )( jQuery );
